









import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class FriendlyDateTime extends Vue {
	@Prop() public date: Date;
	@Prop({default: 'never'}) public placeholder: string;

	public get actualDate(): string {
		return moment(this.date).format('lll');
	}

	public get relativeDate(): string {
		if (!this.date) {
			return this.placeholder;
		}

		return moment(this.date).fromNow();
	}

	private get isUnknown() {
		return !this.date && this.placeholder !== 'never';
	}
}
